module.exports = __webpack_public_path__ + "img/_icon_business.01575ea5.svg";